import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

export const MissingModuleEmptyState = ({ requestSource }: { requestSource: string }) => {
  return (
    <UpsellingKit.EmptyState
      moduleRequested={AvailableModules.projects}
      featureRequested={Features.projects_management}
      requestReason={ValidReasons.MissingAddon}
      requestSource={requestSource}
      title={i18n.t('finance.contacts.contact_details.projects.upsell_title')}
      description={i18n.t('finance.contacts.contact_details.projects.upsell_description')}
      buttonLabel={i18n.t('common.contact_support')}
    />
  )
}
